var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tgoi4uo6aa",
    d: "M0 0.634L125.831 0.634 125.831 99 0 99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nadv1em4mc",
    d: "M-0.003 0.634L125.827 0.634 125.827 99 -0.003 99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d20yd6ogue",
    d: "M0.498 0.634L126.329 0.634 126.329 99 0.498 99z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M242.414 397.927c-4.694 0-8.5-3.806-8.5-8.5V200.84c0-4.695 3.806-8.5 8.5-8.5s8.5 3.805 8.5 8.5v188.586c0 4.694-3.806 8.5-8.5 8.5",
    transform: "translate(33 51)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M427.575 412.252c-4.694 0-8.5-3.806-8.5-8.5v-77.19c0-26.31-21.404-47.714-47.713-47.714H113.465c-26.309 0-47.713 21.404-47.713 47.713v77.191c0 4.694-3.806 8.5-8.5 8.5-4.695 0-8.5-3.806-8.5-8.5v-77.19c0-35.684 29.03-64.714 64.713-64.714h257.897c35.683 0 64.713 29.03 64.713 64.713v77.191c0 4.694-3.806 8.5-8.5 8.5M142.478 17c-6.472 0-11.736 5.265-11.736 11.737v147.41c0 6.472 5.264 11.737 11.736 11.737h199.87c6.472 0 11.737-5.265 11.737-11.737V56.777c0-6.47-5.265-11.736-11.737-11.736H236.433c-7.706 0-14.985-3.742-19.473-10.008L204.051 17h-61.573zm199.87 187.884h-199.87c-15.846 0-28.736-12.89-28.736-28.737V28.737C113.742 12.891 126.632 0 142.478 0h63.244c4.432 0 8.614 2.153 11.19 5.76l13.871 19.377c1.301 1.818 3.415 2.904 5.65 2.904h105.915c15.846 0 28.737 12.891 28.737 28.736v119.37c0 15.846-12.89 28.737-28.737 28.737z",
    transform: "translate(33 51)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 51) translate(0 348.709)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sai2mpvprb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tgoi4uo6aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC6F3",
    d: "M57.04 15.314c-.886 0-1.72-.428-2.234-1.148l-8.863-12.38c-.516-.723-1.35-1.152-2.237-1.152H2.749c-1.52 0-2.75 1.23-2.75 2.748v92.87C0 97.768 1.23 99 2.75 99h120.333c1.519 0 2.749-1.23 2.749-2.749V18.063c0-1.519-1.23-2.749-2.75-2.749H57.04z",
    mask: "url(#sai2mpvprb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 51) translate(359 348.709)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "exccnkm13d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nadv1em4mc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC6F3",
    d: "M57.037 15.314c-.887 0-1.719-.428-2.235-1.148l-8.863-12.38c-.515-.723-1.348-1.152-2.236-1.152H2.745c-1.518 0-2.748 1.23-2.748 2.748v92.87c0 1.517 1.23 2.748 2.748 2.748h120.334c1.518 0 2.748-1.23 2.748-2.749V18.063c0-1.519-1.23-2.749-2.748-2.749H57.037z",
    mask: "url(#exccnkm13d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 51) translate(179 348.709)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dhgs3nue2f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d20yd6ogue"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC6F3",
    d: "M57.539 15.314c-.887 0-1.72-.428-2.235-1.148L46.44 1.786c-.515-.723-1.35-1.152-2.237-1.152H3.247c-1.52 0-2.75 1.23-2.75 2.748v92.87c0 1.517 1.23 2.748 2.75 2.748H123.58c1.518 0 2.748-1.23 2.748-2.749V18.063c0-1.519-1.23-2.749-2.748-2.749H57.539z",
    mask: "url(#dhgs3nue2f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M316.596 103.26H168.233c-3.867 0-7-3.135-7-7 0-3.867 3.133-7 7-7h148.363c3.866 0 7 3.133 7 7 0 3.865-3.134 7-7 7M316.596 143.98H168.233c-3.867 0-7-3.134-7-7s3.133-7 7-7h148.363c3.866 0 7 3.134 7 7s-3.134 7-7 7",
    transform: "translate(33 51)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDs);
export default __webpack_public_path__ + "static/media/icon--ds.036c07053e8927001d59de98f249d03b.svg";
export { ForwardRef as ReactComponent };